import createClient from "openapi-fetch";
import type { paths } from "./api-types.js";

/**
 * The API client, typed from the server's own OpenAPI document.
 *
 * AGENTS.md §15a bans hand-written request and response types because they
 * drift — and the drift is invisible until a screen renders undefined. These
 * come from `packages/contracts/openapi.json`, so a route changing shape in
 * that document is a compile error here rather than a runtime surprise. Node
 * emitted the document from its route schemas; since Node was removed
 * (2026-10-17) it is kept by hand, and the parity suite checks every response
 * the Rust API sends against it.
 *
 * Same origin: the dev server proxies /api, and in production the app is served
 * behind the same host. Nothing about the API's address is compiled in — the
 * base comes from wherever the page itself was served, at runtime.
 *
 * Stated as a base rather than left as a bare relative path. They mean the same
 * thing to a browser, and only one of them means anything to `fetch` outside
 * one: a relative URL reaches Node's fetch as "Failed to parse URL", which is
 * how the first component test discovered this.
 */
export const api = createClient<paths>({
  baseUrl: window.location.origin,
  credentials: "same-origin",
});
